import { render, staticRenderFns } from "./primary-contact.vue?vue&type=template&id=155b9f6b&scoped=true"
import script from "./primary-contact.vue?vue&type=script&lang=js"
export * from "./primary-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b9f6b",
  null
  
)

export default component.exports